import { NgTemplateOutlet } from '@angular/common';
import { Component, Input, ViewEncapsulation } from '@angular/core';

import { EmailImageAssetDirective } from '../../directives/email-image-asset.directive';
import { EmailMailgunEachDirective } from '../../directives/email-mailgun-each.directive';
import { SsrMarkToUnwrapDirective } from '../../directives/ssr-markto-unwrap.directive';
import { WrappedValue } from '../../mailgun/wrap-value';
import { MailgunRelativePathPipe } from '../../pipes/mailgun-relative-path.pipe';
import { CampaignContractSubmittedTemplateTemplateData } from '../../templates/campaign-contract-submitted-template/campaign-contract-submitted-template.component';
import { EmailButtonComponent } from '../email-button/email-button.component';
import { EmailLinkComponent } from '../email-link/email-link.component';
import { EmailMarginComponent } from '../email-margin/email-margin.component';
import { EmailTextComponent } from '../email-text/email-text.component';

@Component({
  standalone: true,
  selector: 'email-campaign-contract-submitted',
  styleUrls: ['./email-campaign-contract-submitted.component.less'],
  template: `
    <email-text [contents]="data.order_summary" size="medium" [bold]="true" />
    <table cellspacing="0" cellpadding="0" class="products">
      <ng-container *mailgunFor="let product of data.products">
        <tr>
          <td align="left" class="product-cell">
            <li><email-text [contents]="product.title" className="product-title" /></li>
          </td>
        </tr>
      </ng-container>

      <tr>
        <td colspan="3" height="28">&nbsp;</td>
      </tr>
      <tr>
        <td colspan="3">
          <hr />
        </td>
      </tr>
      <tr>
        <td colspan="3" height="28">&nbsp;</td>
      </tr>
    </table>

    <email-text [contents]="data.body" size="medium" />
    <email-margin [height]="20" />
    <email-button [href]="data.primary_cta.href" [label]="data.primary_cta.label" theme="primary" />
  `,
  hostDirectives: [SsrMarkToUnwrapDirective],
  encapsulation: ViewEncapsulation.None,
  imports: [
    EmailImageAssetDirective,
    NgTemplateOutlet,
    SsrMarkToUnwrapDirective,
    MailgunRelativePathPipe,
    EmailMailgunEachDirective,
    EmailMarginComponent,
    EmailTextComponent,
    EmailLinkComponent,
    EmailButtonComponent,
  ],
})
export class EmailCampaignContractSubmittedComponent {
  @Input() public data: WrappedValue<CampaignContractSubmittedTemplateTemplateData>;
}
